

let appid="wx66d335d265a279b5";
let redirectUrl = encodeURIComponent("https://www.ioofox.com");
export default `https://open.weixin.qq.com/connect/qrconnect?appid=${appid}&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_login&state=3d6be0a4035d839573b04816624a415e#wechat_redirect`;


// WEBPACK FOOTER //
// ./src/config/wechat.js